<template>
<div class="chapter">
<div class="inner_page">
<p class="verse"><i>I am Glandion.</i></p>
<p class="verse"><i>I am a contemplative.</i></p>
<p class="verse"><i>I embrace the life and role of the Holy Spirit.</i></p>
<p class="verse"><i>I love a good wine.</i></p>
<p class="verse"><i>I love fellowship and friendships.</i></p>
<p class="verse"><i>I am a deep, caring person.</i></p>
<p class="verse"><i>I am a worrier and a burden bearer.</i></p>
<p class="verse"><i>I take time to notice.</i></p>
<p class="verse"><i>I am soft-spoken yet strong in spirit.</i></p>
<p class="verse"><i>I love jazz, as well as the Gregorian chant.</i></p>
<p class="verse"><i>I am consciously aware of my sinful nature.</i></p>
<p class="verse"><i>I am a great listener.</i></p>
<p class="verse"><i>I am a priest, a husband and father of four adult children.</i></p>
<p class="verse"><i>I am a grandpa, affectionately called “Papa.”</i></p>
<p class="verse"><i>I long to remain in the presence of God.</i></p>
<p class="verse"><i>I like to celebrate.</i></p>
<p class="verse"><i>I don’t have to act in a cultural manner to define my African American identity.</i></p>
<p class="verse"><i>I am a crosscultural man.</i></p>
<p class="verse"><i>I think about my death about once a week.</i></p>
<p class="verse"><i>I think about my life and want to do the things that matter.</i></p>
<p class="verse"><i>I love to laugh yet I cry easily.</i></p>
<p class="verse"><i>I love poetry, especially T. S. Eliot and Garrison Keillor.</i></p>
<p class="verse"><i>I love coffee.</i></p>
<p class="verse"><i>I question myself all the time.</i></p>
<p class="verse"><i>I have never sensed the condemnation of God.</i></p>
<p class="verse"><i>I don’t think about former accomplishments as much as my</i> <i>failures.</i></p>
<p class="verse"><i>I believe in justice.</i></p>
<p class="verse"><i>I have stood in lines in Ethiopia with the hungry and the poor.</i></p>
<p class="verse"><i>I have traveled to eastern Africa during the time of genocide, war and famine.</i></p>
<p class="verse"><i>I minister in one of the wealthiest communities in the United States.</i></p>
<p class="verse"><i>I have learned that the rich in resources can also be poor in spirit.</i></p>
<p class="verse"><i>I embrace the Scriptures and see them as a guidepost for life.</i></p>
<p class="verse"><i>I have struggled to accept the diagnosis of a disease and tried to cover it up.</i></p>
<p class="verse"><i>I love the Father, Son and Holy Spirit.</i></p>
<p class="verse"><i>I love the Eucharist.</i></p>
<p class="verse"><i>I embrace another person’s heart, whatever their religious practice.</i></p>
<p class="verse"><i>I believe evil will be overcome.</i></p>
<p class="verse"><i>I love to see the sunset.</i></p>
<p class="verse"><i>I take time to look in the eyes of others to get a glimpse of their heart.</i></p>
<p class="verse"><i>I like to raid the cookie jar in the middle of the night.</i></p>
<p class="verse"><i>I love theological discussions.</i></p>
<p class="verse"><i>I am loved.</i></p>
<p class="verse"><i>I am loving.</i></p>
<p class="verse"><i>I am Glandion.</i></p>
<p class="verse"><i>I have Parkinson’s.</i></p>
<p class="verse"><i>I am learning to walk in grace.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prose.vue?27d7f475